import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  relatedPrograms: {
    id: 'learner-dash.courseCard.banners.relatedPrograms',
    description: 'title for related programs banner',
    defaultMessage: 'Related Programs: ',
  },
  expandBanner: {
    id: 'learner-dash.courseCard.banners.expandBanner',
    description: 'expand banner button text',
    defaultMessage: 'More',
  },
  expandBannerAlt: {
    id: 'learner-dash.courseCard.banners.expandBannerAlt',
    description: 'expand banner button alt text',
    defaultMessage: 'Expand banner icon',
  },
  collapseBanner: {
    id: 'learner-dash.courseCard.banners.collapseBanner',
    description: 'collapse banner button text',
    defaultMessage: 'Less',
  },
  collapseBannerAlt: {
    id: 'learner-dash.courseCard.banners.collapseBannerAlt',
    description: 'collapse banner button alt text',
    defaultMessage: 'Collapse banner icon',
  },
});

export default messages;
